import moment from "moment";

export const getDateString = (date, time = true) => {
    const formatType = time ? "DD/MM/YYYY hh:mm" : "DD/MM/YYYY";
    if (new Date(date)) return moment(date).format(formatType);
};
